
import React, { useState, useEffect, useRef } from "react"
import { toast } from "react-toastify"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import {
  calculateTotalTaxes,
  // convertOrderCombosToCartCombos,
  // convertOrderItemsToCartItems,
  // createOfflineOrder
} from "utils"
import { Button } from "components"
import { cancelOrder } from "services"
import { addRefundToShift } from "@redux"
import classes from "./OrderDetailCancelModalFooter.module.scss"

const OrderDetailCancelModalFooter = props => {
  const {
    form,
    total,
    order,
    setOrders,
    setFormErrors,
    setShowConfirmationModal,
    initialFormErrorsState
  } = props

  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const [sending, setSending] = useState(false)

  const unmount = useRef(false)

  const addRefundReport = () => {
    const totalDiscount =
      order.deliveryDiscount +
      order.foodDiscount

    const totalTaxes =
      calculateTotalTaxes(order)

    dispatch(
      addRefundToShift(
        total,
        totalTaxes,
        totalDiscount
      )
    )
  }

  // const handleOfflineCancel = () => {
  //   const totalDiscount =
  //     order.deliveryDiscount +
  //     order.foodDiscount

  //   const totalTaxes =
  //     calculateTotalTaxes(order)

  //   const offlineOrderDetails = {
  //     onlineOrderId: order._id,
  //     total: order.totalBillAmount,
  //     code: order.code,
  //     totalTaxes,
  //     totalDiscount,
  //     totalCharges: 0,
  //     orderStatus: "canceled",
  //     onlineInitialOrderStatus: "paid",
  //     deliveryType: order.deliveryType,
  //     deliveryAddress: order.address,
  //     deliveryService: order.deliveryService,
  //     order: {
  //       tableNumber: order.tableNumber,
  //       items: convertOrderItemsToCartItems(order.items),
  //       combos: convertOrderCombosToCartCombos(order.items)
  //     },
  //     deliveryFees: {
  //       fee: order.deliveryFee
  //     }
  //   }

  //   createOfflineOrder(offlineOrderDetails)

  //   setShowConfirmationModal(false)
  // }

  const validate = () => {
    let result = true
    const errors = { ...initialFormErrorsState }

    if (form.cancelReasons.length > 300) {
      result = false
      errors.cancelReasons = t("دلیل_لغو_سفارش_طولانی_است")
    }

    setFormErrors(errors)

    return result
  }

  const handleCancel = async () => {
    if (!validate()) return

    setSending(true)

    try {
      await cancelOrder(
        order._id,
        {
          refundType: form.refundType,
          cancelReasons: form.cancelReasons
        }
      )

      const reportRefund =
        form.refundType === "cash" &&
        order.orderStatus === "paid"

      reportRefund && addRefundReport()

      if (unmount.current) return

      setOrders(prev =>
        prev.map(o =>
          o._id === order._id
            ? { ...o, orderStatus: "canceled" }
            : o
        )
      )

      setShowConfirmationModal(false)
    } catch (err) {
      console.log(err)

      toast.error(t("سفارش_لغو_نشد"))

      setSending(false)
    }
  }

  useEffect(() => {
    unmount.current = false

    return () => unmount.current = true
  }, [])

  const disableApproveButton =
    order.orderStatus === "paid" &&
    Number(total) !== Number(form.amount)

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["buttonContainer"]}>
      <Button
        color="danger"
        disabled={sending}
        onClick={() => setShowConfirmationModal(false)}
      >
        {t("خیر")}
      </Button>

      <Button
        color="success"
        loading={sending}
        className={clsx(classes["yesButton"], isLtr && classes["yesButton"])}
        disabled={disableApproveButton}
        onClick={handleCancel}
      >
        {t("بله")}
      </Button>
    </div>
  )
}

export default OrderDetailCancelModalFooter